<template>
    <v-row
        justify="center"
    >
        
        <v-col>        
            <v-card
                class="mx-auto pa-0"
                width="1000"
                height="80vh"
                flat
            >
                <v-card-title
                    class="d-flex white--text pb-4 px-0"
                >
                    <v-spacer></v-spacer>
                    <div 
                        v-if="displayCocurricularClasses" 
                        class=" font-weight-bold primary--text text-uppercase"
                    >
                        {{ academicYear }} Term {{ term }} - {{ lessonSelected.subjectTitle }} Mark Sheet
                    </div>

                    <div 
                        v-else
                        class=" font-weight-bold primary--text text-uppercase"
                    >
                        {{ academicYear }} Term {{ term }} - Co-Curricular Mark Sheet
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon               
                        color="red"
                        @click="displayMarkSheetMenu"
                    >
                        <v-icon>mdi-window-close</v-icon>
                    </v-btn>            
                </v-card-title>

                
                <v-row class=" mt-4">
                    <v-col class="py-0">
                        <Header
                            @filter-students-by-class="filterStudentsByClass"
                        />
                        
                        <MarkSheetTable
                            :selectedClasses="selectedClasses"
                            :coCurricularStudents="coCurricularStudents"
                            :coCurricularClubs="coCurricularClubs"
                        />
                    </v-col>
                </v-row>
                

                <v-card-actions class="mt-4">
                    <v-spacer></v-spacer>
                    <v-btn depressed @click="displayMarkSheetMenu">Close Mark Sheet</v-btn>
                </v-card-actions>
               
                <v-overlay
                    absolute
                    :value="overlay"                    
                    color="grey lighten-5"
                    opacity="0.9"
                    class="pa-5"
                >                    
                    
                    <Lesson 
                        v-if="displayLessons"
                        @cocurricular="displayClassesCocurricular"
                    />
                    
                    <Teacher 
                        v-if="displayTeachers"
                    />

                    <MarkSheetCocurricular 
                        :expand="displayCocurricularClasses"
                        @close-classes="closeCocurricularClasses"
                        @display-cocurricular-marksheet="displayCocurricularMarksheet"
                    />

                    <v-progress-circular 
                        transition="fade-transition" 
                        indeterminate 
                        size="64"
                        v-if="loading"
                        color="primary"
                    ></v-progress-circular> 
                </v-overlay>
            </v-card>
        </v-col>
        
    </v-row>    
</template>

<script>
import Header from './MarkSheetHeader'
import Lesson from './MarkSheetLesson'
import Teacher from './MarkSheetTeacher'
import MarkSheetTable from './MarkSheetTable'
import { mapGetters, mapMutations } from 'vuex'
import MarkSheetCocurricular from './MarkSheetCocurricular'
export default {
    name: 'MarkSheet',

    created () {
        this.initialize();
    },
  
    components: {
        Header,
        Lesson,
        Teacher,
        MarkSheetTable,
        MarkSheetCocurricular,
    },

    computed: {
        ...mapGetters({            
            overlay: 'markSheet/getMarkSheetOverlay',
            loading: 'markSheet/getMarkSheetLoading',
            totalStudents: 'markSheet/getTotalStudents',
            admin: 'auth/getAdmin',
            displayLessons: 'markSheet/getDisplayLessons',
            displayTeachers: 'markSheet/getDisplayTeachers',
            lessonSelected: 'markSheet/getLessonSelected',
            academicYear: 'app/getAcademicYear',
            term: 'app/getTerm',
            editTermReport: 'auth/getEditTermReport',
        }), 
    },
    
    watch: {
       //
    },

    data: () => ({
        userTimetable: [],
        selectedClasses: [],
        displayCocurricularClasses: false,
        coCurricularStudents: [],
        coCurricularClubs: [],
    }),

    methods: {
        ...mapMutations({
            setOverlay: 'markSheet/setMarkSheetOverlay',
            setMarkSheetLoading: 'markSheet/setMarkSheetLoading',
            setDisplayLessons: 'markSheet/setDisplayLessons',
            setDisplayTeachers: 'markSheet/setDisplayTeachers',                       
        }),

        initialize () {
            this.displayMarkSheetMenu()               
        },
                      
        displayMarkSheetMenu () {
            this.setOverlay(true);
            if(this.admin || this.editTermReport){
                this.setDisplayLessons(false);
                this.setDisplayTeachers(true);                
            }
            else {
                this.setDisplayLessons(true);
                this.setDisplayTeachers(false);
            }           
        },

        filterStudentsByClass (selectedClasses) {
            this.selectedClasses = selectedClasses
        },

        displayClassesCocurricular () {
            this.displayCocurricularClasses = true;
        },

        closeCocurricularClasses() {
            this.displayCocurricularClasses = false;
        },

        displayCocurricularMarksheet (dataStudents, dataClubs) {
            this.coCurricularStudents = dataStudents,
            this.coCurricularClubs = dataClubs
            this.setOverlay(false);
        },
       
    }
}
</script>